/* eslint-disable no-console */
import * as Sentry from "@sentry/react";
const PRODUCTION_MODE = 'production'

export function debugLog(message: any, ...optionalParams: any[]): void {
  if (process.env.REACT_APP_MODE !== PRODUCTION_MODE) {
    Sentry.logger.debug(message, ...optionalParams)
  }
}

export function infoLog(message: any, ...optionalParams: any[]): void {
  if (process.env.REACT_APP_MODE !== PRODUCTION_MODE) {
    Sentry.logger.info(message, ...optionalParams)
  }
}

export function errorLog(message: any, ...optionalParams: any[]): void {
  if (process.env.REACT_APP_MODE !== PRODUCTION_MODE) {
    Sentry.logger.error(message, ...optionalParams)
  }
}
